import { action, observable } from 'mobx';
import { HttpClient, setMap } from 'Mri.Web.Common';

export class AccountsStore {
    public constructor(httpClient: HttpClient) {
        this.httpClient = httpClient;
    }

    @action
    public async loadAllAsync(cache = false) {
        const accounts = await this.httpClient.get<Mri.Accounts.Account[]>(`/api/v1/accounts`, {
            cache,
        });

        setMap(this.accounts, accounts, a => a.accountNumber);
    }

    @action
    public async loadMonitoringActiveAsync(cache = false) {
        const accounts = await this.httpClient.get<Mri.Accounts.Account[]>(`/api/v1/accounts/monitoring-active`, {
            cache,
        });

        setMap(this.monitoringActiveAccounts, accounts, a => a.accountNumber);
        return accounts;
    }

    @action
    public async loadAsync(accountNumber: string) {
        const account = await this.httpClient.get<Mri.Accounts.Account>(`/api/v1/accounts/${accountNumber}`);

        if (account) this.accounts.set(accountNumber, account);
    }

    @action
    public async importAsync(model: Mri.Web.Internal.Controllers.Accounts.ImportAccountModel) {
        await this.httpClient.post<Mri.Accounts.Account>(`/api/v1/accounts/import`, model);
        await this.loadAllAsync();
    }

    @action
    public async updateAsync(accountNumber: string) {
        const account = await this.httpClient.put<Mri.Accounts.Account>(`/api/v1/accounts/${accountNumber}/import`);

        if (account) this.accounts.set(account.accountNumber, account);
    }

    @action
    public async toggleActiveAccount(accountNumber: string, active: boolean) {
        const account = await this.httpClient.put<Mri.Accounts.Account>(
            `/api/v1/accounts/${accountNumber}/active/${active}`
        );

        if (account) {
            this.accounts.set(account.accountNumber, account);
        }
    }

    @action
    public async deleteAsync(accountNumber: string) {
        await this.httpClient.delete(`/api/v1/accounts/${accountNumber}`);

        this.accounts.delete(accountNumber);
    }

    @observable
    public accounts = new Map<string, Mri.Accounts.Account>();
    @observable
    public monitoringActiveAccounts = new Map<string, Mri.Accounts.Account>();

    private readonly httpClient: HttpClient;
}
